/**
*  UI-REFACTORED
*    FROM --> ./legacy-web/src/main/js/apps/common/js/jquery/aacom/plugins/aaMegaNav.js
*    TO   --> ./webapps/shared-web/src/main/assets/js/legacy/plugins/aa-mega-nav.js
**/

/*
 * aaMegaNav.js
 */
(function($) {
    $('[data-behavior~="meganav-content"]').hide();
    var $content = $('[data-behavior~="meganav-content"]');

    $content.addClass('js-meganav-content');

    var $openMenus;
    var $closeBar = $('<a class="close-bar"><span></span></a>');

    $closeBar.addClass('shadow12-up');

    $closeBar.click(function(e) {
        $openMenus = $('[data-behavior~="meganav-content"].is-open');
        closeAll();
    });

    $('[data-behavior~="meganav"] a').click(function(e) {
        e.preventDefault();

        var menu = $(this).attr('data-menu');
        var $target = $(this);
        $openMenus = $('[data-behavior~="meganav-content"].is-open');

        if ($(this).hasClass('is-current')) {
            closeAll();
        } else if ($openMenus.length === 0) {
            jQuery(document).find(menu).append($closeBar).slideDown().addClass('is-open');
            $target.addClass('is-current');
        } else {
            $openMenus.hide();
            $('[data-behavior~="meganav"] .is-current').removeClass('is-current');
            jQuery(document).find(menu).show().append($closeBar).addClass('is-open');
            $target.addClass('is-current');
        }
    });

    var closeAll = function(callback) {
        $('[data-behavior~="meganav"] .is-current').removeClass('is-current');

        if (callback) {
            if ($openMenus.length > 0) {
                $openMenus.slideUp(function() {
                    if ($('[data-behavior~="meganav-content"].is-open:animated').length === 0) {
                        callback();
                    }
                }).removeClass('is-open');
            } else {
                callback();
            }
        } else {
            if ($openMenus.length > 0) {
                $openMenus.slideUp().removeClass('is-open');
            }
        }
    };
})(jQuery);

var initPageSlideTransition = function() {
    var _is_WindowOrientationChanged = false;
    var _is_PageSlideOpen = false;

    if(jQuery(".pageslide-button").hasClass('ui-state-initialized')){
		return;
	}

    jQuery(window).bind("orientationchange", function() {
        _is_WindowOrientationChanged = true;
        if (_is_PageSlideOpen) {
            closePageSlide();
        }
    });
    jQuery(window).resize(function() {
        if (typeof ($device) !== 'undefined' && $device.viewport() != 'phone' && _is_PageSlideOpen) {
            closePageSlide();
        }
    });

    jQuery(".pageslide-button").click(function(event) {
        var pageSlideId = jQuery(this).attr("href");
        var pageSlidePos = jQuery(this).attr("data-position");
        if (!_is_PageSlideOpen) {
            openPageSlide(pageSlideId, pageSlidePos, this);
        } else {
            closePageSlide();
        }
        return false;
    });

    var openPageSlide = function(pageSlideId, pageSlidePos, pageSlideBtn) {
        var _pageSlideWidth = 260;
        var _animationTime = 300;
        if (pageSlidePos == "right") {
            jQuery("body").css({
                left : ""
            }).animate({
                right : _pageSlideWidth
            }, _animationTime);
            jQuery(pageSlideId).css({
                right : -_pageSlideWidth
            });
        } else {
            jQuery("body").css({
                right : ""
            }).animate({
                left : _pageSlideWidth
            }, _animationTime);
            jQuery(pageSlideId).css({
                left : -_pageSlideWidth
            });
        }
        jQuery("body").css("overflow-x", "hidden");
        jQuery(pageSlideId).addClass("pageslide");
        jQuery(".pageslide-row").css({
            position : "inherit"
        });
        (pageSlideBtn != undefined) ? jQuery(pageSlideBtn).addClass("icon-on") : jQuery(".pageslide-button")
                .addClass("icon-on");

        _is_PageSlideOpen = true;
    };
    var closePageSlide = function() {
        var _body = jQuery("body");
        if (_body.css("left") > 0) {
            var _animateElement = {
                left : 0
            };
        } else {
            var _animateElement = {
                right : 0
            };
        }
        jQuery("body").animate(_animateElement, 300, function() {
            jQuery(this).find(".pageslide-row").css({
                position : ""
            });
            jQuery(this).find(".pageslide").removeAttr("style");
            jQuery(this).find(".pageslide").removeClass("pageslide");
            jQuery("body").css("overflow-x", "");
        });
        jQuery(".pageslide-button").removeClass("icon-on");

        _is_PageSlideOpen = false;

    };
    return;
};

/*
 * the following code is for the new header and is copied from core-1.0.0.js and was modified so that it will
 * work for all for all versions of jQuery used on the site, excluding responsive pages
 */

var initMastheadNavTransition = function() {
    var expanders = jQuery('[data-behavior=toggle-nav]'), navigation = jQuery('#navigation'), close = jQuery('#close'), commonLinks = jQuery('#nav-common-links'), subNavLinks = jQuery('.sub-nav-links'), animationTime = 300;

    if(navigation.hasClass('ui-state-initialized')){
		return;
	}

    subNavLinks.append(commonLinks.html());

    if (jQuery && jQuery.fn.on) {
        expanders
                .on('click', function(ev) {
                    ev.preventDefault();
                    var expander = jQuery(this), container = expander.parent('li');

                    var href = (expander.attr('href') != undefined) ? expander.attr('href') : expander
                            .attr('data-toggle-href');
                    var sanitizedHref = (href !== undefined && href !== null) ? href.replace(/[^a-zA-Z0-9\-_]/g, '') : '';
                    var target = jQuery('#' + sanitizedHref);

                    openMenu(expanders, navigation, container, target, expander);
                });
    } else {
        expanders
                .live('click', function(ev) {
                    ev.preventDefault();
                    var expander = jQuery(this), container = expander.parent('li');

                    var href = (expander.attr('href') != undefined) ? expander.attr('href') : expander
                            .attr('data-toggle-href');
                    var sanitizedHref = (href !== undefined && href !== null) ? href.replace(/[^a-zA-Z0-9\-_]/g, '') : '';
                    var target = jQuery('#' + sanitizedHref);

                    openMenu(expanders, navigation, container, target, expander);
                });
    }

    if (jQuery && jQuery.fn.on) {
        close.on('click', function(ev) {
            closeMenu(ev, expanders, navigation);
        });
    } else {
        close.live('click', function(ev) {
            closeMenu(ev, expanders, navigation);
        });
    }

	var openMenu = function(expanders, navigation, container, target, expander) {
	    if (navigation.hasClass('opened')) {
	        if (container.hasClass('opened')) {
	            initAnimation(target, expander, container, navigation, true);
	        } else {
	            expanders.each(function() {
	                jQuery(this).removeClass('opened');
	                jQuery(this).parent('li').removeClass('opened');
	                jQuery(this).parent('li').find('.sub-nav-links').hide();
	                jQuery(this).find('i').removeClass('icon-collapse').addClass('icon-expand');
	            });

	            expander.addClass('opened');
	            container.addClass('opened');
	            target.show();
	            expander.find('i').removeClass('icon-expand').addClass('icon-collapse');
	        }
	    } else {
	        initAnimation(target, expander, container, navigation, false);
	    }

	}

	var closeMenu = function(ev, expanders, navigation) {
	    ev.preventDefault();
	    if (navigation.hasClass('opened')) {
	        expanders.each(function() {
	            var expander = jQuery(this);
	            if (expander.hasClass('opened')) {
	                var container = expander.parent('li')
	                var target = container.find('.sub-nav-links');
	                initAnimation(target, expander, container, navigation, true);
	            }
	        });
	    }
	}

	var initAnimation = function(target, expander, container, navigation, close) {
	    target.stop().animate({
	        'height' : 'toggle'
	    }, {
	        duration : 0,
	        complete : function() {
	            if (close) {
	                jQuery('#close').hide();
	            } else {
	                jQuery('#close').show();
	            }
	            expander.find('i').toggleClass('icon-expand').toggleClass('icon-collapse');
	            navigation.toggleClass('opened');
	            container.toggleClass('opened');
	            expander.toggleClass('opened');
	            jQuery(this).css('height', '');
	        }

	    });
	}
};
jQuery(document).ready(function() {
    initMastheadNavTransition();
    initPageSlideTransition();
});
